import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Images", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Set a form background and banner image.", -1)
const _hoisted_3 = { class: "ion-margin-top ion-margin-bottom" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h6", null, "TAP TO BROWSE FILE", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Accepted files: JPG, JPEG, PNG, GIF", -1)
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h6", null, "TAP TO BROWSE FILE", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "Accepted files: JPG, JPEG, PNG, GIF", -1)
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h6", null, "TAP TO BROWSE FILE", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "Accepted files: JPG, JPEG, PNG, GIF", -1)
const _hoisted_13 = { class: "container" }

import { save, close } from "ionicons/icons";
import {
  IonLabel,
  IonPage,
  IonItem,
  IonGrid,
  IonButton,
  IonLoading,
  IonIcon,
  IonRow,
  IonCol,
  IonFooter,
  IonContent,
} from "@ionic/vue";
import { useContextStore } from "@/stores/context";
import { reactive } from "vue";
import { editEvent } from "@/api/events";
import { handleError } from "@/views";


export default /*#__PURE__*/_defineComponent({
  __name: 'Images',
  setup(__props) {

const contextStore = useContextStore();

const state = reactive({
  loading: false,
});

const readFile = async ($event: any) => {
  const target = $event.target as HTMLInputElement;
  if (target.files) {
    let file = target.files[0];
    const form = new FormData();
    form.append("file", file);
  }
  state.loading = true;
};

const openFileDialog = (file_input_id: string) => {
  document.getElementById(file_input_id)?.click();
};

const submit = async () => {
  state.loading = true;
  await editEvent({ ...contextStore.event }).catch((err) => {
    state.loading = false;
    handleError(err);
  });

  state.loading = true;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonItem), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonLabel), null, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(IonItem), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), { position: "stacked" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Logo image ")
                  ]),
                  _: 1
                }),
                _createElementVNode("div", {
                  class: "box",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (openFileDialog('banner-file-upload')))
                }, [
                  (_unref(contextStore).event.logo_image)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _unref(contextStore).event.logo_image,
                        alt: ""
                      }, null, 8, _hoisted_4))
                    : _createCommentVNode("", true),
                  _hoisted_5,
                  _hoisted_6,
                  _createElementVNode("input", {
                    id: "banner-file-upload",
                    type: "file",
                    onChange: readFile,
                    style: {"display":"none"}
                  }, null, 32)
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(IonItem), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), { position: "stacked" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Banner image ")
                  ]),
                  _: 1
                }),
                _createElementVNode("div", {
                  class: "box",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (openFileDialog('banner-file-upload')))
                }, [
                  (_unref(contextStore).event.image)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _unref(contextStore).event.image,
                        alt: ""
                      }, null, 8, _hoisted_7))
                    : _createCommentVNode("", true),
                  _hoisted_8,
                  _hoisted_9,
                  _createElementVNode("input", {
                    id: "banner-file-upload",
                    type: "file",
                    onChange: readFile,
                    style: {"display":"none"}
                  }, null, 32)
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(IonItem), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), { position: "stacked" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Background image ")
                  ]),
                  _: 1
                }),
                _createElementVNode("div", {
                  class: "box",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (openFileDialog('background-file-upload')))
                }, [
                  (_unref(contextStore).event.background_image)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _unref(contextStore).event.background_image,
                        alt: ""
                      }, null, 8, _hoisted_10))
                    : _createCommentVNode("", true),
                  _hoisted_11,
                  _hoisted_12,
                  _createElementVNode("input", {
                    id: "background-file-upload",
                    type: "file",
                    onChange: readFile,
                    style: {"display":"none"}
                  }, null, 32)
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(IonFooter), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("section", null, [
              _createVNode(_unref(IonGrid), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonRow), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCol), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonButton), {
                            expand: "block",
                            color: "light",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (submit()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), {
                                slot: "start",
                                icon: _unref(close)
                              }, null, 8, ["icon"]),
                              _createTextVNode(" Cancel ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonCol), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonButton), {
                            expand: "block",
                            color: "success",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (submit()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), {
                                slot: "start",
                                icon: _unref(save)
                              }, null, 8, ["icon"]),
                              _createTextVNode(" Save ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(IonLoading), {
        "is-open": state.loading,
        message: "Please wait..."
      }, null, 8, ["is-open"])
    ]),
    _: 1
  }))
}
}

})